<template>
  <div class="mask" v-show="text">
    <div class="maskBox">
      <img style="display: block; width: 100%" src="../../assets/nullIcon.png" />
      <p class="words">{{ text }}</p>
    </div>
  </div>
</template>
<script setup lang="ts">
import { NAMES } from "@/config/config";
import { computed, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
const store = useStore();
const route = useRoute();

const arr = ["请先创建财务账套", "请先创建进销存信息"];
const text = ref();
const thisCompany = computed(() => store.getters.getThisCompany);

watch(
  [thisCompany, route],
  ([thisCompany, route]) => {
    const { isHavePsi, isHaveAccount } = thisCompany;
    const name = route.name as NAMES;
    if ([NAMES.FINANCIAL, NAMES.FINANCIAL_LIST, NAMES.FISCAL_ANALYSIS, NAMES.BUDGET].includes(name) && isHaveAccount == 0) {
      text.value = arr[0];
    } else if ([NAMES.PURCHASE].includes(name) && isHavePsi == 0) {
      text.value = arr[1];
    } else text.value = "";
    console.log({ isHavePsi, isHaveAccount }, name);
  },
  { immediate: true }
);
</script>
<style lang="less" scoped>
.mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  .maskBox {
    width: 24%;
    > .words {
      text-align: center;
      color: #999;
      font-size: 1vw;
    }
  }
}
</style>
